module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAJcEhZcwAAAEgAAABIAEbJaz4AAAAzUExURUxpccDAwL+/v8HBwb+/v76+vsDAwL+/v8DAwMDAwL+/v8DAwL+/v7+/v8DAwMDAwL+/v0efADQAAAAQdFJOUwDsMAzjHVa7+ETVKGqCxKc83WX3AAAA0ElEQVR42u3V2wqEMAxF0fRqWqvm/792EOJYGF9yCgOK531tSqlI794B8xPXMuALiwjnIa8F2GsB91rwgwFZ7TyFvsB2H9e+UO1epCtwAbwWYH8WcK8Fs5/VHwXcawH1ujbolz97757l28184Wf5TMZFhfBfYI5Dfknk3YAPHBPNEfbURLSAeaqiBdB72Vf3AuRpkbOAeHLyLQTEZzlWIU/TwZcE+cS75q1AWq+wtkDwYtSjg0uF7ju/TYZt/uITMq1evGDT3E+gOZPP9O5dtw/hWSdaGn9vmwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/imgs/movie/edit.png
// module id = YVfU
// module chunks = 1